import { JWTService } from '@services/jwt.service';

import { ApiServiceV1 } from '@services/api.service';

export const AuthApiService = {
  async checkUserAuth() {
    try {
      await ApiServiceV1.get('auth/validate', {
        headers: {
          Authorization: `bearer ${JWTService.getToken()}`,
        },
      });

      return Promise.resolve();
    } catch (e) {
      JWTService.removeToken();

      return Promise.reject(e);
    }
  },
};

export default AuthApiService;
